import hollandTest from "@helpers/data/hollandTest.json";
import profTest from "../components/ProfTest.json";

export const HOLLAND_TYPE_API = {
  Р: "HollandR",
  И: "HollandI",
  А: "HollandA",
  С: "HollandS",
  П: "HollandE",
  К: "HollandC",
};

export const SECTION_ORDER = ["activities", "abilities", "careers"];

export const HOLLAND_TYPE_ORDER = hollandTest.typeOrder || [
  "Р",
  "И",
  "А",
  "С",
  "П",
  "К",
];

function createEmptyScores(types = HOLLAND_TYPE_ORDER) {
  const scores = {};
  types.forEach((type) => {
    scores[type] = { total: 0, bySection: {} };
  });
  return scores;
}

function sortTypesByScore(scores) {
  return Object.entries(scores)
    .sort(([, a], [, b]) => b.total - a.total)
    .map(([type]) => type);
}

/** SDS-style checklist scoring (legacy ProfTest). */
export function computeHollandScores(answers) {
  const types = Object.keys(HOLLAND_TYPE_API);
  const scores = createEmptyScores(types);

  SECTION_ORDER.forEach((sectionKey) => {
    const section = profTest.sections[sectionKey];
    const sectionAnswers = answers[sectionKey] || {};

    section.items.forEach((item, index) => {
      if (sectionAnswers[index]) {
        if (!scores[item.type].bySection[sectionKey]) {
          scores[item.type].bySection[sectionKey] = 0;
        }
        scores[item.type].bySection[sectionKey] += 1;
        scores[item.type].total += 1;
      }
    });
  });

  const sortedTypes = sortTypesByScore(scores);
  const hollandCode = sortedTypes.slice(0, 3).join("");

  return { scores, hollandCode, sortedTypes };
}

/**
 * Pair-choice Holland questionnaire (42 steps).
 * answers: { [questionId]: "a" | "b" }
 */
export function computeHollandPairScores(
  answers,
  questions = hollandTest.questions
) {
  const scores = createEmptyScores();

  questions.forEach((question) => {
    const choice = answers[question.id] ?? answers[String(question.id)];
    if (choice !== "a" && choice !== "b") return;

    const option = question[choice];
    if (!option?.type || !scores[option.type]) return;

    scores[option.type].total += 1;
  });

  const sortedTypes = sortTypesByScore(scores);
  const hollandCode = sortedTypes.slice(0, 3).join("");

  return { scores, hollandCode, sortedTypes };
}

export function buildHollandApiParams(scores) {
  const max = Math.max(...Object.values(scores).map((item) => item.total), 1);
  const params = {};

  Object.entries(HOLLAND_TYPE_API).forEach(([type, apiKey]) => {
    params[apiKey] = Number(((scores[type]?.total || 0) / max).toFixed(4));
  });

  return params;
}

export function buildHollandResultPayload(answers) {
  const { scores, hollandCode, sortedTypes } = computeHollandScores(answers);

  return {
    completedAt: new Date().toISOString(),
    answers,
    scores,
    hollandCode,
    sortedTypes,
    hollandApi: buildHollandApiParams(scores),
    version: "checklist",
  };
}

export function buildHollandPairResultPayload(
  answers,
  questions = hollandTest.questions
) {
  const { scores, hollandCode, sortedTypes } = computeHollandPairScores(
    answers,
    questions
  );

  return {
    completedAt: new Date().toISOString(),
    answers,
    scores,
    hollandCode,
    sortedTypes,
    hollandApi: buildHollandApiParams(scores),
    version: "pairs-42",
  };
}

export function getHollandTypeInfo(type) {
  return (
    hollandTest.typeDescriptions?.[type] ||
    profTest.typeDescriptions?.[type] ||
    null
  );
}
